import React from "react";
import CustomErrorField from "../../../../Form/CustomErrorField";
import './parseData.css';
import api from "../../../../../api";
import { Button, Checkbox,Dropdown,Table,Loader,Dimmer, Popup, Icon } from 'semantic-ui-react'
import { fas } from "@fortawesome/free-solid-svg-icons";
import {countrieslist,statelist,address_terms} from "./CountriesList";
import Modal from "../../../ChatSetup/components/Modal";
import ConfirmDialog from "../../../../Modal/ConfirmDialog";
import axios from "axios";
import config from "../../../../../config";
import { FixedSizeList as List } from 'react-window';



class DataParseRule extends React.Component {
    countries=countrieslist;
    states = statelist;
   address_fields=address_terms;
   state_terms={usa:'State',canada:'Province',aus:'State'} ;
   zip_terms={usa:'Zip Code',canada:'Postal Code',aus:'Postcode'} ;  
    
    constructor(props){
        super(props);
        this.state={
            listOfData : [{rule:"",edit:true,required:false,date_required:false,is_address:false,map:false,field_type:'',rule_has_variables:false,direct_variable_value:false,dynamic_rule:false}],
             backupdata : [],
            showNotification:false,
            alertData:{type:"sucess",message:"Data Parse Rule Updated Successfully."},
            is_required:false,
            date_required:false,
             timezone:"",
            timezones:"",
            useAddress:false,
            state:'',
            country:"",
            auto_sent:false,
            modalOpen:false,
            modalBody:'',
            modalFooter:'',
            modalTitle:"",
            curField:'',
            curIndex:-1,
            filerror:"",
            theInputKey:'',
            errType:'error',
            errorMessage:'',
            isValid:false,
            useZipCodeLoaction: false,
            searchTerm: '',
            confirmDialog:false,
            resetconfirmDialog: false,
            enableDirectVariableValues: false,
            enableDynamicRules: false,
        }
       this.fileref=React.createRef(null);
        
    }
    onload = () => {
        api.botbuilder.getParseDaataConfigration({workspace_id:atob(this.props.workspace_id)}).then( res => {
            if(res.data && res.data.length > 0){
                let reslist=res.data;
                let  resplist=reslist.map((resp,ind) => {
                    if (resp?.is_address && !resp.isZipCode) {                        
                        const isZipCode = Object.values(this.zip_terms).some(v => v.toLowerCase() === resp.rule.trim().toLowerCase());
                        resp.isZipCode = isZipCode;
                    }

                    return this.normalizeParseRule(resp, ind);
                  });
                this.setState({
                    listOfData : resplist,
                    backupdata : resplist,
                    timezones:res.timezones,
                    is_required : res.is_required,
                    datetime_required : res.date_required,
                    timezone:res.timezone,
                    useAddress:res.use_address,
                    auto_sent:res.auto_sent,
                    state:res.state,
                    country:res.country,
                    useZipCodeLoaction: res.useZipCodeLoaction,
                    enableDirectVariableValues: typeof res.enableDirectVariableValues !== 'undefined' ? !!res.enableDirectVariableValues : resplist.some((item) => item.direct_variable_value),
                    enableDynamicRules: typeof res.enableDynamicRules !== 'undefined' ? !!res.enableDynamicRules : resplist.some((item) => item.dynamic_rule)
                    
                })
            }else{
                this.setState({
                    listOfData : [ this.normalizeParseRule({rule:"",edit:true,name:''}, 0) ],
                    timezones:res.timezones,
                    country:'',
                    state:"",
                    enableDirectVariableValues: false,
                    enableDynamicRules: false
                })
            }
        }
        )
        .catch((err) => {
            console.log(err)
        })
    }
    timeZoneOption = () => {
        let list = Object.keys(this.state.timezones).map((key, index) => {
            return {
                key: index,
                text: this.state.timezones[key],
                value: key
            }
        });
        return list;
    }
    handleTimeZoneSelect = (e, { value }) => {
        const timeZoneName = value;
         if(timeZoneName.length>0) {
            const timeZoneValue = this.state.timezones[timeZoneName];        
            let currentTime = new Date().toLocaleString("en-US", { timeZone: timeZoneName });
            this.setState({timezone:timeZoneName}) ;
         } else{
          this.setState({timezone:""}) ;
         }  
        
       
    }


    handleCountries = (e, { value }) => {
         let prevstat=this.state.country;
         let fields=this.state.listOfData;
         fields=fields.filter((it)=>{
            return  it.is_address!=true
        });
         if(value.length>0) {
            fields=fields.filter((f)=>{
               
                return !this.address_fields[value].includes(f.rule.trim());
           });
                for(let i=0;i<this.address_fields[value].length;i++){
                    let rullname=this.address_fields[value][i];                                        
                    const isZipCode = Object.values(this.zip_terms).some(v => v.toLowerCase() === rullname.trim().toLowerCase());                    
                    fields.push(this.normalizeParseRule({rule:rullname,required:true,name:rullname.trim().toLowerCase(),date_required:false,is_address:true,edit:false,index:fields[fields.length-1].index+1, isZipCode}, fields[fields.length-1].index+1));
                    
                }
         } 
         this.setState({country:value,listOfData:fields});

    }
    handlestates=(e, { value }) => {
        if(value.length>0) {
            this.setState({state:value}) ;
         } else{
          this.setState({state:""}) ;
         }  
    }

    componentDidMount(){
        this.onload()
    }
    normalizeParseRule = (rule = {}, index = 0) => {
        const directVariableValue = typeof rule.direct_variable_value !== 'undefined'
            ? !!rule.direct_variable_value
            : rule.field_type === 'variable';
        const dynamicRule = typeof rule.dynamic_rule !== 'undefined'
            ? !!rule.dynamic_rule
            : !!rule.rule_has_variables;

        return {
            required: false,
            date_required: false,
            is_address: false,
            isZipCodeLocation: false,
            dynamic_rule: false,
            ...rule,
            field_type: directVariableValue ? 'variable' : (dynamicRule ? 'rule_variable' : ''),
            rule_has_variables: dynamicRule,
            direct_variable_value: directVariableValue,
            dynamic_rule: dynamicRule,
            index: typeof rule.index !== 'undefined' && rule.index !== null ? rule.index : index
        };
    }
    markrequired=()=>{
        let req=!this.state.is_required;
        this.setState({is_required:req});
    }
    markAutoSent=()=>{
        let req=!this.state.auto_sent;
        this.setState({auto_sent:req});
    }
    
    daterequired=()=>{
        let req=!this.state.datetime_required;
        this.setState({datetime_required:req});
    }
    useAddress=()=>{
        let req=!this.state.useAddress;
       let fields= this.state.listOfData;
       let country=this.state.country;
       country=['usa','canada','aus'].includes(country) ? country:'';
        fields=fields.filter((it)=>{
            return  it.is_address!=true
        });
        if(req && country.trim()!=='' && ['usa','canada','aus'].includes(country)){
            fields=fields.filter((f)=>{
                return !this.address_fields[country].includes(f.rule.trim());
           });
            for(let i=0;i<this.address_fields[country].length;i++){
                let rullname=this.address_fields[country][i];                
                const isZipCode = Object.values(this.zip_terms).some(v => v.toLowerCase() === rullname.trim().toLowerCase());
                fields.push(this.normalizeParseRule({rule:rullname,name:rullname.trim().toLowerCase(),required:true,date_required:false,is_address:true,edit:false,index:fields[fields.length-1].index+1, isZipCode}, fields[fields.length-1].index+1));
            }
        }
       
        this.setState({useAddress:req,listOfData:fields});
    }
    makerequired=(val,i)=>{
        let fields=this.state.listOfData;
        fields[i].required=!fields[i].required
        this.setState({listOfData:fields}); 
        
    }
    
    makedtrequired=(val,i)=>{
        let fields=this.state.listOfData;
        fields[i].date_required=!fields[i].date_required;
        this.setState({listOfData:fields}); 
        
    }

    markaddress=(val,i)=>{
        let fields=this.state.listOfData;
        fields[i].is_address=!fields[i].is_address
        
       
        this.setState({listOfData:fields}); 
    }
    toggleDirectVariableValues = () => {
        const enableDirectVariableValues = !this.state.enableDirectVariableValues;
        const listOfData = enableDirectVariableValues ? this.state.listOfData : this.state.listOfData.map((item) => ({
            ...item,
            direct_variable_value: false,
            field_type: ''
        }));

        this.setState({ enableDirectVariableValues, listOfData });
    }
    toggleDynamicRules = () => {
        const enableDynamicRules = !this.state.enableDynamicRules;
        const listOfData = enableDynamicRules ? this.state.listOfData : this.state.listOfData.map((item) => ({
            ...item,
            dynamic_rule: false,
            rule_has_variables: false
        }));

        this.setState({ enableDynamicRules, listOfData });
    }
    markDirectVariableValue = (i) => {
        const fields = [...this.state.listOfData];
        const currentField = { ...fields[i] };
        const directVariableValue = !currentField.direct_variable_value;

        fields[i] = {
            ...currentField,
            direct_variable_value: directVariableValue,
            field_type: directVariableValue ? 'variable' : ''
        };

        this.setState({ listOfData: fields });
    }
    markDynamicRule = (i) => {
        const fields = [...this.state.listOfData];
        const currentField = { ...fields[i] };
        const dynamicRule = !currentField.dynamic_rule;

        fields[i] = {
            ...currentField,
            dynamic_rule: dynamicRule,
            rule_has_variables: dynamicRule
        };

        this.setState({ listOfData: fields });
    }
    renderParseConfigration = () => {
        const activeCheckboxColumns = [
            this.state.is_required,
            this.state.datetime_required,
            this.state.useAddress,
            this.state.enableDirectVariableValues,
            this.state.enableDynamicRules
        ].filter(Boolean).length;

        let colsize = 'col-md-10';
        if (activeCheckboxColumns === 1 || activeCheckboxColumns === 2) {
            colsize = 'col-md-9';
        } else if (activeCheckboxColumns === 3) {
            colsize = 'col-md-8';
        } else if (activeCheckboxColumns === 4) {
            colsize = 'col-md-7';
        } else if (activeCheckboxColumns >= 5) {
            colsize = 'col-md-6';
        }
          console.log("this.state.listOfData",this.state.listOfData);
        return (
          
            this.state.listOfData.map((rule, index,arr) => {
                let rules = typeof rule.rule != 'undefined' ? rule.rule.split("(") : [];
                let keypart = typeof rules[0] != 'undefined' ? rules[0].trim() : '';
                let commpart = typeof rules[1] != 'undefined' ? rules[1] : '';
                let ncommpart = commpart.replaceAll(",", "").replaceAll(")", "").trim();
                commpart = commpart.length > 0 && commpart.includes(")") ? commpart.slice(0, -1) : '';
                let delflag=true;
                if(rule.is_address && this.state.useAddress){
                    delflag=false;
                }
                if(rule.is_address && !this.state.useAddress){
                    delflag=true;
                }
                return (<li className="row mb-3">
                    {this.state.is_required && <div className="col-1">
                        <Checkbox
                            onChange={(e) => this.makerequired(rule.rule, index)}
                            checked={rule.required}

                        />

                    </div>}
                    {this.state.datetime_required && <div className="col-1">
                        <Checkbox
                            onChange={(e) => this.makedtrequired(rule.rule, index)}
                            checked={rule.date_required}
                            className="datecheckbox"
                            disabled={rule.is_address}
                        />

                    </div>}

                    {this.state.useAddress && <div className="col-1">
                        <Checkbox
                            onChange={(e) => this.markaddress(rule.rule, index)}
                            checked={rule.is_address}
                            disabled={true}
                            className="isaddress"
                        />

                    </div>}
                    {this.state.enableDirectVariableValues && <div className="col-1">
                        <Checkbox
                            onChange={() => this.markDirectVariableValue(index)}
                            checked={rule.direct_variable_value}
                            className="directvariablecheckbox"
                            disabled={rule.is_address}
                        />

                    </div>}
                    {this.state.enableDynamicRules && <div className="col-1">
                        <Checkbox
                            onChange={() => this.markDynamicRule(index)}
                            checked={rule.dynamic_rule}
                            className="dynamicrulecheckbox"
                            disabled={rule.is_address}
                        />

                    </div>}
                    {/* {this.state.useZipCodeLoaction &&
                        <div className="col-1">
                            <Checkbox
                                onChange={(e) => this.onSelectZipCodeLocation(rule.rule, index)}
                                checked={rule.isZipCodeLocation}
                                disabled={false}
                                className="isZipCodeLoction"
                            />

                        </div>
                    } */}
                    <div className={colsize} id={`row_${index}`}>
                        <input id={`field_${index}`} type="text" className="form-control" placeholder="Parse Rule" onBlur={(event) => this.handleBlur(index, event.target.value)} onChange={(event => this.handleParseRuleChange(index, event.target.value))} value={rule.rule} defaultValue={rule.rule} disabled={!rule.edit} />
                    </div>
                    {/* { !rule.edit && <div className="col-1"><button type="button" className="icon-btn-spl" onClick={this.handleEdit(index)}><i class="la la-edit blue" title="Edit"></i></button></div>} */}
                    {(this.state.listOfData.length > 1 && !rule.isZipCode) &&
                        <div className="col-1">{delflag  && <button disabled={!delflag} style={{ marginTop: '-8px' }} type="button" className="icon-btn-spl" onClick={this.removeParseRule(index, rule)}><i class="la la-trash red" title="Delete"></i></button>}
                        </div>}
                      {rule.isZipCode && <div className="col-1">
                      {(rule?.map?.length>0)  && <button  style={{ marginTop: '-4px',fontSize:'15px' }} type="button" className="icon-btn-spl" onClick={()=>this.resetZiprules(index, rule)}><i class="fa fa-refresh red" title="Reset zipcodes"></i></button>}
                      </div>}   
                    {rule.isZipCode ? (
                        <>
                            <div className="col-1">{(rule?.map?.length>0) && <button style={{ marginTop: '-8px', marginLeft: '10px' }} type="button" className="icon-cog-spl" onClick={(e) => this.configZipCodeValues(index, rule, commpart, keypart)}><i class="fa fa-cog" title="Configure values"></i></button>}

                                {( rule?.rule && !rule?.map?.length>0 && !rule?.date_required && !(rule.rule.includes('[') && rule.rule.includes(']'))) && <button style={{ marginTop: '-8px', marginLeft: '10px' }} type="button" className="icon-cog-spl" onClick={(e) => this.uploadFileandconfire(index, rule, commpart, keypart)}><i class="fa fa-upload" title="Configure values"></i></button>}


                            </div>
                        </>
                    ) : (
                        <>
                            <div className="col-1">{(!rule.is_address && ncommpart.length > 0 && commpart.trim().length > 0 && rule.rule.includes(")")) && <button disabled={rule.is_address} style={{ marginTop: '-8px', marginLeft: '10px' }} type="button" className="icon-cog-spl" onClick={(e) => this.configfieldVals(index, rule, commpart, keypart)}><i class="fa fa-cog" title="Configure values"></i></button>}

                                {( delflag && ncommpart.length === 0 && commpart.trim().length === 0 && !rule?.rule.includes(")") && !rule?.date_required && !(rule.rule.includes('[') && rule.rule.includes(']'))) && <button disabled={!delflag} style={{ marginTop: '-8px', marginLeft: '10px' }} type="button" className="icon-cog-spl" onClick={(e) => this.uploadFileandconfire(index, rule, commpart, keypart)}><i class="fa fa-upload" title="Configure values"></i></button>}


                            </div>
                        </>
                    )}
                </li>);
            }
            ))
    }

    closeModal=()=>{
        // let cur_index=this.state.curIndex;
        // let lists=this.state.listOfData;
        // let clist=lists[cur_index];

        this.setState({modalOpen:false,curIndex:-1,curField:'',modalBody:'',modalFooter:'',filerror:"",errType:'error',theInputKey:Math.random(),loading:false});
    }
   
    getParseValues=(val,prev)=>{
        let map_values=this.state.map_values;
        let keydata=typeof val.rule!='undefined' ? val.rule.split("("): val.split("(");
        let prevdata=typeof prev!='undefined' ? prev.split("("): '';
        let values=[];
        let exitstvalue=typeof map_values[keydata[0].trim()]!='undefined' ? map_values[keydata[0].trim()]:'';
       
        if(exitstvalue && exitstvalue.length>0){
            values=exitstvalue;
        }
        let values1=keydata[1].length ? keydata[1].slice(0,-1):"";
        values1=values1.length>0 ? values1.split(","):[];

     
        values=values1.map(value=>{
            if(prevdata.length>0){
                let exist=typeof map_values[prevdata[0]]!='undefined' ? map_values[prevdata[0]]:'';
                
            }
            return {key:value.trim().toLowerCase(),name:value,value:""};
        });
        
        return values;
    }    
   toggleRevenueMatch = (index, key, value) => {
    let editIndexData = [...this.state.listOfData];
    let parseCodeJson = editIndexData[index];
    let mapItem = parseCodeJson.map.find(item => item.key === key);

    if (mapItem) {
        mapItem.required_for_revenue_match = value;
        // Update the whole list
        this.setState({ listOfData: editIndexData }, () => {
            // Re-render modalBody after state update
            let body = this.configBody(parseCodeJson, key, index);
            this.setState({ modalBody: body });
        });
    }
};

    configBody = (values, key, i) => {
        let mapData = values.map || [];
        if (mapData.length > 0) {
            return (
                <Table id="additional_captured">
                    <Table.Body>
                        {mapData.map((vl) => (
                            <Table.Row key={vl.key}>
                                <Table.Cell>{vl.name}</Table.Cell>
                                <Table.Cell>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vl.value}
                                        name={vl.key}
                                        onChange={(e) => this.updateMapping(e, vl, i)}
                                    />
                                </Table.Cell>
                                <Table.Cell>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <label style={{ margin: 0 }}>Required for Revenue Match</label>
                                        <span className="kt-switch kt-switch-sm kt-switch--success chat-cus-check acceptattachemnt" style={{ margin: 0 }}>
                                            <label style={{ margin: 0 }}>
                                                <input
                                                    type="checkbox"
                                                    name="chatPopup"
                                                    onChange={(e) => this.toggleRevenueMatch(i, vl.key, e.target.checked)}
                                                    checked={vl.required_for_revenue_match || false}
                                                />
                                                <span />
                                            </label>
                                        </span>
                                    </div>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            );
        }
        return <p>No Data</p>;
    }
    
    updateMapping = (e, vl, index, type = "") => {
        let lists = [...this.state.listOfData];
        let curlist = lists[index];
        let curmap = curlist.map ? [...curlist.map] : [];
    
        if (curmap.length > 0) {
            curmap = curmap.map(it => {
                if (it.key.trim() === vl.key.trim()) {
                    return { ...it, value: e.target.value };
                }
                return it;
            });
            console.log(curmap);
            
            curlist.map = curmap;
            lists[index] = { ...curlist, map: curmap };
            
            this.setState({ listOfData: lists }, () => {
                if (!type) {
                    let body = this.configBody(curlist, vl.key, index);
                    this.setState({ modalBody: body });    
                }                
            });
        }
    }
    saveconfig=(e)=>{
       this.setState({curField:'',modalOpen:false});
       this.saveDataParsetRule();

    }
    uploadFile=async (e,index,rule,commpart,keypart)=>{
        const selectedFile = e.target.files[0];
        let err=false;
        if (!selectedFile) {
           this.setState({filerror:"Please select a file."},()=>{
            let body=this.formbody(index,rule,commpart,keypart);
            this.setState({modalBody:body});
           });
          err=true;
        }else{
            if (selectedFile.type !== 'text/csv') {
                this.setState({filerror:"The uploaded file must be a CSV  file."},()=>{
                    let body=this.formbody(index,rule,commpart,keypart);
                    this.setState({modalBody:body,theInputKey:Math.random()});
                   });
                   err=true;
              }
        
              if (selectedFile.size > 2 * 1024 * 1024) {
                this.setState({filerror:"The uploaded file may not be greater than 2MB."},()=>{
                    let body=this.formbody(index,rule,commpart,keypart);
                    this.setState({modalBody:body,theInputKey:Math.random()});
                   });
                   err=true;
              }
        }
        if(err){
            setTimeout(() => {
                this.setState({
                    filerror:"",
                     errType:'error',
                },()=>{
                    let body=this.formbody(index,rule,commpart,keypart);
                    this.setState({modalBody:body,filerror:""});
                })
                
            }, 5000);
            return false;
        }else{
            this.setState({filerror:"",loading:true,theInputKey:Math.random()},()=>{
                let body=this.formbody(index,rule,commpart,keypart);
                this.setState({modalBody:body});
            });
            const formData = new FormData();
            formData.append("csv_file", selectedFile);
            formData.append("workspace_id", atob(this.props.workspace_id));
            formData.append("index", index);
            formData.append("rule", rule.rule);
            formData.append("isZipCode", rule.isZipCode ? rule.isZipCode : false);
            try {
                if (this.fileref.current) {
                    this.fileref.current.value = "";
                  }
                const response = await axios.post(`${config.apiBaseURL2}botbuilder/uploadParsefile`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });
                console.info(response.data,"response file");
               if(response.data.status){
                let parsedata=this.state.listOfData;
                if(typeof parsedata[index]!='undefined'){
                    console.log('ppoint1---',response.data?.data,response.data?.data?.map,response.data?.data?.rule,response.data?.data?.name,index);
                    parsedata[index]['map']=response.data?.data?.map;
                    parsedata[index]['rule']=response.data?.data?.rule;
                    parsedata[index]['name']=response.data?.data?.name;
                }else{
                      console.log('ppoint2---');
                    parsedata.push(this.normalizeParseRule({rule:response.data?.data?.rule,name:response.data?.data?.name ?? keypart,required:false,date_required:false,is_address:false,map:response.data.data?.map,index:parsedata[parsedata.length-1].index+1}, parsedata[parsedata.length-1].index+1));
                      console.log('ppoint3---',parsedata);
                }
                 console.log('ppoint4---',parsedata);
                
                    this.setState({
                        listOfData:parsedata,
                        
                        loading:false,
                        filerror:"Data saved successfully.",
                        errType:'success'
                    },()=>{
                        let body=this.formbody(index,rule,commpart,keypart);
                         this.setState({modalBody:body});
                    });
                    
                    setTimeout(() => {
                        this.setState({
                            filerror:"File process successfully.",
                             errType:'error',
                             modalOpen:false,modalBody:"",modalFooter:"",modalTitle:"",
                        },()=>{
                            let body=this.formbody(index,rule,commpart,keypart);
                            this.setState({modalBody:body,filerror:""});
                            this.saveDataParsetRule();
                             window.scrollTo(0,0); 
                        })
                        
                    }, 5000);
               }else{
                console.warn(response.data,"response file");
                    this.setState({
                        loading:false,
                        filerror:response.data.message,
                        theInputKey:Math.random(),
                         errType:'error'
                    },()=>{
                        let body=this.formbody(index,rule,commpart,keypart);
                        this.setState({modalBody:body});
                    });
    
                    setTimeout(() => {
                        this.setState({
                            loading:false,
                            filerror:"",
                            theInputKey:Math.random()
                        },()=>{
                            let body=this.formbody(index,rule,commpart,keypart);
                            this.setState({modalBody:body});
                        });
                    }, 4000);
                   
                    
               }
              } catch (error) {
                console.error(error,"file error");
                this.setState({
                    loading:false,
                    filerror:"File process failed.",
                    theInputKey:Math.random(),
                     errType:'error'
                },()=>{
                    let body=this.formbody(index,rule,commpart,keypart);
                    this.setState({modalBody:body});
    
                });
    
                setTimeout(() => {
                    this.setState({
                        loading:false,
                        filerror:"",
                        theInputKey:Math.random()
                    },()=>{
                        let body=this.formbody(index,rule,commpart,keypart);
                        this.setState({modalBody:body});
                    });
                }, 4000);
              
              }

        }
       
    }

    formbody=(index,rule,commpart,keypart)=>{
        return(<div className="form">
             {this.state.loading &&  <Loader active>Loading</Loader>}
               
            {(this.state.filerror && this.state.errType=='success') && typeof this.state.filerror==='string' && <p className="text-success">{this.state.filerror}</p>}
            <div className="form-group">
                <label className="form-label">Upload CSV File</label>
                <input type="file" className="form-control" accept=".csv" ref={this.fileref}  key={this.state.theInputKey || '' } onChange={(e)=>this.uploadFile(e,index,rule,commpart,keypart)} />
                {(this.state.filerror && this.state.errType=='error') && typeof this.state.filerror==='string' && <p className="text-danger">{this.state.filerror}</p>}
            {(this.state.filerror && typeof this.state.filerror==='object' && this.state.errType==='error') && <div>
                 {Object.entries(this.state.filerror).map(([key, value]) => (
                    <p className="text-danger" key={key}>{value}</p>
                ))}

                </div>}
                <a href='/assets/parsedatasample.csv' download style={{marginTop:'5px',display:'block'}}>Download our sample CSV file</a>
            </div>
        </div>);
    }
    uploadFileandconfire=(index,rule,commpart,keypart)=>{
        let body=this.formbody(index,rule,commpart,keypart);
        let footer=(<div className="modal-footer"> </div>);
        let allList = this.state.listOfData;
        if (rule.is_address && !rule.isZipCode) {                        
            const isZipCode = Object.values(this.zip_terms).some(v => v.toLowerCase() === rule.rule.trim().toLowerCase());
            allList[index].rule.isZipCode = isZipCode;
        }

        this.setState({listOfData: allList, modalOpen:true,modalBody:body,modalFooter:footer,modalTitle:`Upload values for field '${keypart}'`,curIndex:index,filerror:"",loading:false});
    }
    resetZiprules=(index, rule) => {
         this.setState({ resetconfirmDialog: true, curIndex: index, curField: rule.rule });
    }
    toggleResetConfirmModal=()=>{
        this.setState({ resetconfirmDialog: !this.state.resetconfirmDialog });  
    }

    deleteZipcodeValues=()=>{
        let index = this.state.curIndex;
        let allParseField = [...this.state.listOfData];
         allParseField[index].map = [];
         this.setState({ listOfData: allParseField, curIndex: -1, curField: '' }, () => {
            this.toggleResetConfirmModal();
         });
           
    }

    configZipCodeValues = (index) => {
        let allParseField = [...this.state.listOfData];
        let currentParseField = allParseField[index];        
        let keyName = currentParseField.rule.trim();

        let zipCodeMap = currentParseField.map ? currentParseField.map.map(item => ({ ...item })) : [];        
        currentParseField = { ...currentParseField, map: zipCodeMap};
        allParseField[index] = currentParseField;

        this.setState({ listOfData: allParseField }, () => {            
            let body = this.configBodyZipCode({ ...currentParseField, map: zipCodeMap }, '', index);
            let footer = (
                <div className="modal-footer">
                    <button
                        type="button"
                        onClick={(e) => this.saveconfig(e)}
                        className="btn linear-gradient yr-submitbtn btn-sm"
                    >
                        <span>Save</span>
                    </button>
                    <button
                        type="reset"
                        className="btn yr-cancelbtn linear-gradient-cancel mg-r"
                        onClick={() => this.closeModal()}
                    >
                        <span>Close</span>
                    </button>
                </div>
            );
            this.setState({
                modalOpen: true,
                modalBody: body,
                modalFooter: footer,
                modalTitle: `Add values for ${keyName}`,
                curField: keyName.trim().toLowerCase(),
                curIndex: index,
                searchTerm: ''
            });
        });
    }

    onChangeZipBody = (e, index) => {
        const searchTerm = e.target.value;
        const currentParseField = this.state.listOfData[index];

        this.setState(
            { searchTerm },
            () => {
                const body = this.configBodyZipCode(currentParseField, '', index);
                this.setState({ modalBody: body });
            }
        );
    };

    configBodyZipCode = (values, key, i) => {
        const { searchTerm } = this.state;
        const mapData = values.map || [];

        const filtered = mapData
            .filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.value.toLowerCase().includes(searchTerm.toLowerCase())
            );

        filtered.sort((a, b) => {
            const nameA = a.value?.trim().toLowerCase() || '';
            const nameB = b.value?.trim().toLowerCase() || '';
            return nameA.localeCompare(nameB);
        });
                

        const Row = ({ index, style }) => {
            const item = filtered[index];
            return (
                <div className="d-flex border-bottom py-2 px-2 align-items-center" style={style}>
                    <div className="col-5">{item.key}</div>
                    <div className="col-7">
                        <input
                            type="text"
                            className="form-control"
                            defaultValue={item.value}
                            name={item.key}
                            onChange={(e) => this.updateMapping(e, item, i, 'zipcode')}
                        />
                    </div>
                </div>
            );
        };

        return (
            <>
                {/* Search */}
                <div className="form-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.onChangeZipBody(e, i)}
                    />
                </div>

                {/* Virtualized List */}
                {filtered.length > 0 ? (
                    <div style={{ height: '300px' }}>
                        <List
                            height={300}
                            itemCount={filtered.length}
                            itemSize={50}
                            width="100%"
                        >
                            {Row}
                        </List>
                    </div>
                ) : (
                    <p>No matching data</p>
                )}
            </>
        );
    };


    configfieldVals = (i, val, valuepart, keypart) => {        
        let index = i;
        let editIndexData = [...this.state.listOfData];
        let parseCodeJson = editIndexData[index];
        let labelsForRule = parseCodeJson.rule || '';
        let keyname = labelsForRule.split('(')[0].trim();
    
        // Log initial map to verify input data
        console.log('Initial map for index', index, parseCodeJson.map);
    
        // Initialize newValmap with existing map to preserve values
        let newValmap = parseCodeJson.map ? parseCodeJson.map.map(item => ({ ...item })) : [];
    
        // Only rebuild map if val.rule is provided (indicating a rule change)
        if (!parseCodeJson.isZipCode && val && val.rule) {
            labelsForRule = val.rule;
            keyname = labelsForRule.split('(')[0].trim();
    
            // Extract values from rule
            let vals = labelsForRule.split('(');
            let valueString = vals[1] ? (vals[1].includes(')') ? vals[1].trim().slice(0, -1) : vals[1].trim()) : '';
            valueString = valueString.replace(/,\s*$/, ''); // Remove trailing comma
            let vlist = valueString.split(',').map(item => item.trim()).filter(item => item.length > 0);
    
            // Remove duplicates
            vlist = [...new Set(vlist)];
    
            // Rebuild map, preserving existing values and adding new keys
            newValmap = [];
            vlist.forEach(key => {
                // Use case-insensitive comparison for matching keys
                let existingItem = parseCodeJson.map ? parseCodeJson.map.find(item => item.key.trim().toLowerCase() === key.trim().toLowerCase()) : null;
                if (existingItem) {
                    // Preserve existing value and original key/name
                    newValmap.push({
                        key: existingItem.key,
                        value: existingItem.value || '',
                        name: existingItem.name,
                        required_for_revenue_match: existingItem.hasOwnProperty('required_for_revenue_match') ? existingItem.required_for_revenue_match : false
                    });
                } else {
                    // Add new key with empty value, using rule's key casing
                    newValmap.push({
                        key: key,
                        value: '',
                        name: key,
                        required_for_revenue_match: false
                    });
                }
            });
        }
    
        // Update specific key-value pair if valuepart and keypart are provided
        if (valuepart && keypart) {
            let targetItem = newValmap.find(item => item.key.trim().toLowerCase() === keypart.trim().toLowerCase());
            if (targetItem) {
                targetItem.value = valuepart;
            }
        }
    
        // Log newValmap to verify preservation of values
        console.log('New map after processing:', newValmap);
    
        // Construct new rule (use updated rule if val.rule provided, else keep original)
        let nrule = val && val.rule ? keyname + (newValmap.length > 0 ? ` (${newValmap.map(item => item.key).join(', ')})` : '') : parseCodeJson.rule;
    
        if (parseCodeJson.isZipCode) {
            nrule = parseCodeJson.rule;
        }

        // Update the data object
        let updatedData = {
            ...parseCodeJson,
            map: newValmap,
            name: keyname,
            rule:  nrule
        };
    
        // Merge additional properties from val, if provided
        if (val && Object.keys(val).length > 0) {
            updatedData = { ...updatedData, ...val, map: newValmap, name: keyname, rule: nrule };
        }
    
        editIndexData[index] = updatedData;
    
        // Log updatedData to verify map before rendering
        console.log('Updated data for modal:', updatedData);
    
        this.setState({ listOfData: editIndexData }, () => {
            // Render modal with updated map

            let displayMap = parseCodeJson.isZipcode ? newValmap : updatedData.map;
            console.log('rule', displayMap);
            
            let body = this.configBody({ ...updatedData, map: displayMap }, keypart, index);

            // let body = this.configBody(updatedData, keypart, index);
            let footer = (
                <div className="modal-footer">
                    <button
                        type="button"
                        onClick={(e) => this.saveconfig(e)}
                        className="btn linear-gradient yr-submitbtn btn-sm"
                    >
                        <span>Save</span>
                    </button>
                    <button
                        type="reset"
                        className="btn yr-cancelbtn linear-gradient-cancel mg-r"
                        onClick={() => this.closeModal()}
                    >
                        <span>Close</span>
                    </button>
                </div>
            );
            this.setState({
                modalOpen: true,
                modalBody: body,
                modalFooter: footer,
                modalTitle: `Add values for ${keyname}`,
                curField: keyname.trim().toLowerCase(),
                curIndex: index
            });
        });
    
        return editIndexData;
    }
    handleEdit = index => () => {
        this.setState({
            listOfData : this.state.listOfData.map((rule,i) => i === index ? {...rule,edit:!rule.edit} : rule)
        })
    }
    validateInput = (text) => {
    // Check for space before opening parenthesis
    const spaceBeforeParenthesis = /[a-zA-Z]\s\(/.test(text);
    
    // Check for space after each comma
    const commasWithoutSpace = /,(?!\s)(?=[^)]*\))/.test(text);
    
    if (!spaceBeforeParenthesis && text.includes('(')) {
      this.setState({
        isValid: false,
        errorMessage: 'Missing space before opening parenthesis'
      });
      return false;
    } else if (commasWithoutSpace) {
      this.setState({
        isValid: false,
        errorMessage: 'Missing space after one or more commas'
      });
       return false;
    } else {
      this.setState({
        isValid: true,
        errorMessage: ''
      });
       return true;
    }
  };
    handleParseRuleChange = (index,value) => {
        let lists=[...this.state.listOfData];
       
        let curlist={...lists[index]};
        let vlaues=value.split("/(/");
       
        let keypart=typeof vlaues[0]!='undefined' ? vlaues[0].trim().toLowerCase():value.trim().toLowerCase();
        curlist={...curlist,rule:value,name:keypart};
        lists[index] = curlist;
        this.setState({listOfData:lists,isValid:true,filerror:"",errorMessage:""},()=>{
            this.state.listOfData.forEach((item,index) => {
                const inpbox= document.getElementById(`field_${index}`);
                inpbox.classList.remove("highlightedbox");
            });
                 
        });
    }
    handleBlur=(index,value) => {
        let lists=[...this.state.listOfData];
        let curlist={...lists[index]};
       let correctedText= this.autoCorrectInput(curlist.rule);
       lists[index].rule=correctedText;
       this.setState({listOfData:lists,isValid:true,filerror:"",errorMessage:""});
    }

  autoCorrectInput = (text) => {
  if (!text) return text;

  let correctedText = text;
  let openParens = 0;
  
  // Count parentheses
  for (const char of correctedText) {
    if (char === '(') openParens++;
    if (char === ')') openParens = Math.max(0, openParens - 1);
  }

  // Apply all transformations
  correctedText = correctedText
    // 1. Exactly one space before opening parenthesis
    .replace(/([a-zA-Z])\s*\(/g, '$1 (')
    // 2. Remove empty entries (commas with nothing or just spaces after them before next comma or parenthesis)
    .replace(/,\s*(?=[,)])/g, '')
    // 3. No spaces before commas, exactly one after (for non-empty entries)
    .replace(/\s*,\s*/g, ', ')
    // 4. No spaces before closing parenthesis
    .replace(/\s*\)/g, ')')
    // 5. No spaces after opening parenthesis
    .replace(/\(\s+/g, '(')
    // 6. Clean multiple spaces between words
    .replace(/(\w)\s+(\w)/g, '$1 $2');

  // Balance parentheses
  if (openParens > 0) {
    correctedText += ')'.repeat(openParens);
  } else if (openParens < 0) {
    correctedText = correctedText.split('')
      .filter((char, i, arr) => {
        if (char === ')' && openParens < 0) {
          openParens++;
          return false;
        }
        return true;
      }).join('');
  }

  return correctedText;
};
    removeParseRule = (index,rule) => () => {
        this.setState({
            listOfData : this.state.listOfData.filter((rule,i) => i !== index),
        })
    }
    addParseRule = () => {
        let lists=[...this.state.listOfData];
        this.setState({
            listOfData : [...this.state.listOfData,this.normalizeParseRule({rule:"",edit:true,name:'',index:lists[lists.length-1].index+1}, lists[lists.length-1].index+1)],  
        });
        // document.getElementById("endrow").scrollIntoView();
    }
    importParseRule = () => {
        this.setState({confirmDialog:false});
        api.botbuilder.importParseDaataConfigration({workspace_id:this.props.workspace_id}).then( res => {
            if(res.status){
                let reslist=res.data;
                 let  resplist=reslist.map(resp => {
                    return this.normalizeParseRule(typeof resp.required=='undefined'? {...resp,required:false,name:'',date_required:false,is_address:false} : resp);
                  });
                    
                 this.onload();
                 this.setState({
                 listOfData : [...resplist,this.normalizeParseRule({rule:"",edit:true,required:false,date_required:false}, resplist.length)],
                 confirmDialog:false
                });
            }
            this.showNotification("import");
           
        }).catch((err) => {
            this.setState({confirmDialog:false})
            console.log(err)
        })
        
    }
    correctRules=()=>{
        let rules=[...this.state.listOfData];
        for (let index = 0; index < rules.length; index++) {
                const item =rules[index];
              let   type_err = this.validateInput(item.rule);

                if (!type_err) {
                   let fixed= this.autoCorrectInput(item.rule);
                    rules[index].rule=fixed;
                   
                }
            }
            this.setState({listOfData:rules});
            return rules;
    }
    saveDataParsetRule = () => {

        if(this.state.is_required==1){
            let fls=this.state.listOfData.filter(item=>item.required==true);
            if(fls.length==0){
                this.setState({
                    alertData:{type : "red",message:"Please mark at least one field as required."},
                    showNotification:true,
                });
                window.scrollTo(0,0);
                setTimeout(() => {
                    this.setState({
                        showNotification:false,
                        alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
                    })
                }, 4000);
                return false;
            }
           
        }

      
       
            let blank=this.state.listOfData.filter(item=>item.rule.trim().length==0);
            if(blank.length>0){
                this.setState({
                    alertData:{type : "red",message:"Data parse rule cannot be blank."},
                    showNotification:true,
                });
                window.scrollTo(0,0);
                setTimeout(() => {
                    this.setState({
                        showNotification:false,
                        alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
                    })
                }, 4000);
                return false;
            }

        if(this.state.enableDirectVariableValues || this.state.enableDynamicRules){
            let hasAnyChecked = this.state.listOfData.some(item => item.direct_variable_value === true || item.dynamic_rule === true);
            if(!hasAnyChecked) {
                this.setState({
                    alertData:{type : "red",message:"Please check the parse rule input checkbox."},
                    showNotification:true,
                });
                window.scrollTo(0,0);
                setTimeout(() => {
                    this.setState({
                        showNotification:false,
                        alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
                    })
                }, 4000);
                return false;
            }
        }

        if(this.state.timezone=="" && this.state.date_required){
            document.getElementById("usetimezone").focus();
                this.setState({
                    alertData:{type : "red",message:"Please select timezone."},
                    showNotification:true,
                });
                window.scrollTo(0,0);
                setTimeout(() => {
                    this.setState({
                        showNotification:false,
                        alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
                    })
                }, 4000);
                return false;
           
        }
        if(this.state.country=="" && this.state.useAddress){
           document.getElementById("countryid").focus();
            this.setState({
                alertData:{type : "red",message:"Please select a country."},
                showNotification:true,
            });
            window.scrollTo(0,0);
            setTimeout(() => {
                this.setState({
                    showNotification:false,
                    alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
                })
            }, 4000);
            return false;
       
    }
       // let  rules= this.correctRules();
        const payloadData = this.state.listOfData.map((item) => {
            const normalizedItem = { ...item };

            delete normalizedItem.direct_variable_value;
            delete normalizedItem.dynamic_rule;

            if (!normalizedItem.field_type) {
                delete normalizedItem.field_type;
            }

            normalizedItem.rule_has_variables = !!normalizedItem.rule_has_variables;

            return normalizedItem;
        });
        let data = {workspace_id:atob(this.props.workspace_id),data:payloadData,is_required:this.state.is_required,date_required:this.state.datetime_required,timezone:this.state.timezone,use_address:this.state.useAddress,country:this.state.country,state:this.state.state,auto_sent:this.state.auto_sent,parse_data:this.state.map_values,backupdata:this.state.backupdata, useZipCodeLoaction: this.state.useZipCodeLoaction, enableDirectVariableValues:this.state.enableDirectVariableValues, enableDynamicRules:this.state.enableDynamicRules};
        let filteredData = data.data.filter( datt => datt.rule.trim() != '')
        if(filteredData.length > 0){
            data = {...data,data:filteredData}
            api.botbuilder.saveParseDaataConfigration({data:data}).then(res => {
                this.showNotification();
                window.scrollTo(0, 0);
                this.onload()

            }).catch((err) => {
                
            })
        }else{
            this.showNotification('alert');
            this.setState({
                alertData:{type : "red",message:""},
                showNotification:true,
            });
        }
        setTimeout(() => {
            this.setState({
                showNotification:false,
                alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
            })
        }, 4000);
    }
    showNotification = (msg = "") => {
        if(msg == "alert"){
            this.setState({
                alertData:{type : "red",message:"Please set at least on data parsing rule."}
            })
        }
        if(msg=='import'){
            this.setState({
                alertData:{type : "sucess",message:"Data imported successfully."}
            })
        }   
        this.setState({
            showNotification:true
        })
        setTimeout(() => {
            this.setState({
                showNotification:false,
                alertData:{type : "sucess",message:"Data Parse Rule Updated Successfully."}
            })
        }, 2000);
    }
   
    userZipCodeLoaction = () => {
        this.setState({
            useZipCodeLoaction : !this.state.useZipCodeLoaction
        })
    }

    onSelectZipCodeLocation = (rule, index) => {
        console.log(index);
        let ruleList = this.state.listOfData;
        console.log(ruleList);        
        ruleList[index].isZipCodeLocation = !ruleList[index].isZipCodeLocation;
        console.log(ruleList);
        this.setState({listOfData:ruleList}); 
    }
    importAction=()=>{
      this.setState({confirmDialog:true});
    }
    toggleConfirmModal=()=>{
        this.setState({confirmDialog:false});
    }

    render(){
        const infoMessage = (
            <div style={{ marginBottom: "10px", lineHeight: "1.7", color: '#495057', fontWeight: '500' }}>
            Use the same variable name that is imported from the webhook in the Outbound Campaign. The variable should be used as it is inside double curly braces <span style={{ background: '#087ab5', color: '#fff', fontWeight: 'bold', padding: '1px 4px', borderRadius: '3px' }}>{'{{}}'}</span><br /> <br />
            Example: If the variable name is <span style={{ background: '#087ab5', color: '#fff', fontWeight: 'bold', padding: '1px 4px', borderRadius: '3px' }}>Dynamic_Variable</span> , it should be used as <span style={{ background: '#087ab5', color: '#fff', fontWeight: 'bold', padding: '1px 4px', borderRadius: '3px' }}>{'{{Dynamic_Variable}}'}</span>.
            </div>
        );
        return (
            <>
            <div className="parsescreen">
                <div className="yr-chat-round-box yr-closebtn">
                    <button
                        type="button"
                        class="close linear-gradient"
                        onClick={() => this.props.popupClose()}
                    >
                        &#10006;
                    </button>
                    <div className="box-title">Add Data Parse Rule 
                        <button type="button" title="Add Data Parse Rule." className="btn btn-sm btn-clean btn-icon" onClick={(e) => this.addParseRule()}>
                            <img src="../../assets/media/icons/plus.svg" alt="" width={15} />
                        </button>
                        {this.props.bot_type=='WEB' && <button
                                    type="button"
                                    title="Import Data Parse Rule From Voice."
                                    className="btn linear-gradient-cancel yr-cancelbtn mg-r"
                                    onClick={(e) => this.importAction()}
                                  >
                                    <span> Import from turbo </span>
                                  </button>
                                 
                       }
                       <p style={{marginLeft:this.state.is_required || this.state.datetime_required ? '-9px': '0'}}>
                                <Checkbox
                                label='Mark Fields Required'
                                onChange={(e) => this.markrequired()}
                                checked={this.state.is_required}
                            />
                           
                             
                        </p> 
                        {this.state.is_required && <p style={{marginLeft:"-10px"}}>
                                <Checkbox
                                label='If all required fields are gathered, feed data automatically'
                                onChange={(e) => this.markAutoSent()}
                                checked={this.state.auto_sent} 
                            />
                            </p>}
                        <p style={{marginLeft:this.state.is_required || this.state.datetime_required ? '-9px': '0'}}>
                        <Checkbox
                        label="Date/Time Required"
                        onChange={(e) => this.daterequired()}
                        checked={this.state.datetime_required}
                        className="datecheckox"
                        />
                        <span style={{marginLeft:"10px"}}>
                        {this.state.timezones && this.state.datetime_required &&
                                   
                                   <Dropdown 
                                        placeholder='Select Time Zone'
                                        search
                                        selection
                                        options={this.timeZoneOption()}
                                        value={this.state.timezone} 
                                        name="timezone"
                                        onChange={this.handleTimeZoneSelect}
                                        clearable
                                        id="usetimezone"
                                    />
                                  
                            }
                        </span>
                       
                        
                         
                    </p> 
                    {(this.props.bot_type == 'OUTBOUND' || this.props.bot_type == 'OUTBOUNDSMS') && <>
                        <p style={{marginLeft:this.state.is_required || this.state.datetime_required ? '-9px': '0'}}>
                                <Checkbox
                                label={{ children: <>Enable Direct Variable Values (Value will be taken directly from variable) <Popup trigger={<Icon name="info circle" style={{ cursor: 'pointer' }} />} wide='very'><Popup.Content>{infoMessage}</Popup.Content></Popup></> }}
                                onChange={() => this.toggleDirectVariableValues()}
                                checked={this.state.enableDirectVariableValues}
                                className="directvariabletoggle"
                                />
                        </p>
                        <p style={{marginLeft:this.state.is_required || this.state.datetime_required ? '-9px': '0'}}>
                                <Checkbox
                                label={{ children: <>Enable Dynamic Rules (Variables will be replaced before sending to AI) <Popup trigger={<Icon name="info circle" style={{ cursor: 'pointer' }} />} wide='very'><Popup.Content>{infoMessage}</Popup.Content></Popup></> }}
                                onChange={() => this.toggleDynamicRules()}
                                checked={this.state.enableDynamicRules}
                                className="dynamicruletoggle"
                                />
                        </p>
                        </>
                    }
                    <p style={{marginLeft:this.state.is_required || this.state.datetime_required ? '-9px': '0'}}>
                                <Checkbox
                                label='Use Address Validation'
                                onChange={(e) => this.useAddress()}
                                checked={this.state.useAddress}
                                 className="addresscheckbox"
                            />
                             <span style={{marginLeft:"10px"}}>
                        { this.state.useAddress &&
                                   <Dropdown 
                                        placeholder='Select Country'
                                        search
                                        selection
                                        options={this.countries}
                                        value={this.state.country} 
                                        name="country"
                                        onChange={this.handleCountries}
                                        clearable
                                        id="countryid"
                                    />
                                  
                            }
                        </span>
                        </p> 

                        <p>
                           
                        { this.state.country && this.state.useAddress &&<> <label style={{color:'rgba(0, 0, 0, .87)',fontSize:'1em'}}>{this.state_terms[this.state.country] } (only choose this if you service one {this.state_terms[this.state.country]})</label>
                            <Dropdown 
                                        placeholder={`Select ${this.state_terms[this.state.country]} `}
                                        search
                                        selection
                                        options={this.states[this.state.country] }
                                        value={this.state.state} 
                                        name="state"
                                        onChange={this.handlestates}
                                        clearable
                                    />
                        </>
                                  
                                  
                            }
                        </p>
                            {/* <p style={{ marginLeft: this.state.is_required || this.state.datetime_required ? '-9px' : '0' }}>
                                <Checkbox
                                    label='Use Zip Code Location'
                                    onChange={(e) => this.userZipCodeLoaction()}
                                    checked={this.state.useZipCodeLoaction}
                                    className="zipCodeLoction"
                                />                                
                            </p>  */}
                    </div>
                    <div className="row">
                        {this.state.showNotification && <div className={`ui message ${this.state.alertData.type === "sucess" ? "green" : "red"}`} >{this.state.alertData?.message}</div>}
                         {this.state.errorMessage && <div className={`ui message red`} >{this.state.errorMessage} in highlighted parsed fields.</div>}
                        
                        <ul className="col-12">
                            {this.renderParseConfigration()}
                        </ul>
                    </div>
                    <div className="row" id="endrow">
                        <div className="col-12 d-flex justify-content-end">
                            <button
                            type="reset"
                            class="btn yr-cancelbtn linear-gradient-cancel mg-r"
                            onClick={() => this.props.popupClose()}
                            >
                                <span> Close </span>
                            </button>
                            <button
                            type="submit"
                            disabled={this.state.listOfData.length==0 || (!this.state.isValid && this.state.errorMessage.length>0)}
                            className="btn linear-gradient yr-submitbtn"
                            onClick={() => this.saveDataParsetRule()}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                 </div>
                 <Modal
                          show={this.state.modalOpen}
                          footer={this.state.modalFooter}
                          onclose={this.closeModal}
                          title={this.state.modalTitle}
                          body={this.state.modalBody}
                />
                {this.state.confirmDialog &&<ConfirmDialog
                                            show={this.state.confirmDialog}
                                            toggleModal={this.importParseRule}
                                            closeAction={this.toggleConfirmModal}
                                            title="Confirm your action"
                                            message={"This action will cease feeding into ServiceTitan bookings.  You will lose all of your ServiceTitan mappings, Notification/Webhook parsed data configurations. Do you really want to import parsed data ?"}
                                        />}

                 {this.state.resetconfirmDialog &&<ConfirmDialog
                                            show={this.state.resetconfirmDialog}
                                            toggleModal={this.deleteZipcodeValues}
                                            closeAction={this.toggleResetConfirmModal}
                                            title="Confirm your action"
                                            message={"This action will delete all uploaded zip code values. Do you really want to delete data ?"}
                                        />}   

        <style>
            {`
            i.icon {
                font-size: 1.2em !important;
            }
                .ui.top.left.popup:before{left:0;right:0;margin:auto;}
            `}

        </style>                    
            </div>
            </>
        )
    }
}
                                 
export default DataParseRule;
